import { render } from "./SongsView.vue?vue&type=template&id=3c34df9c"
import script from "./SongsView.vue?vue&type=script&lang=js"
export * from "./SongsView.vue?vue&type=script&lang=js"

import "./SongsView.vue?vue&type=style&index=0&id=3c34df9c&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__